import { Outlet } from 'react-router-dom';

function JobPlacementLayout() {
  return <Outlet />;
}

export default JobPlacementLayout;
